<div
  class="min-h-screen mx-auto px-4 flex flex-col"
  *ngIf="config"
  [class.max-w-5xl]="config.screenRatio < 1"
  [class.max-w-xl]="config.screenRatio >= 1"
>
  <div id="logo-wrapper">
    <img [src]="getLogoUrl()" alt="Logo">
  </div>

  <content-block [slug]="'default-survey-top'" id="default-survey-top-wrapper"
                 [class.hidden]="boothMode"></content-block>
  <content-block [slug]="'wbm-survey-top'" id="wbm-survey-top-wrapper" [class.hidden]=" ! boothMode"></content-block>

  <!-- user-form.component.html -->
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="grid gap-4">
    <ng-container *ngFor="let item of formConfig.block">

      <ng-container *ngIf="item.type != 'input.hidden'">

      <label [for]="item.key" class="block font-semibold">{{ item.label }}</label>

      <input *ngIf="item.type == 'input.text'"
             [id]="item.key"
             type="text"
             [formControlName]="item.key"
             autocomplete="off"
             (keyup)="runChecks(item.key, $event, item.checks)"
             [class.error]="form.get(item.key)?.invalid && form.get(item.key)?.touched"
      />

      </ng-container>

      <input *ngIf="item.type == 'input.hidden'"
             [id]="item.key"
             type="hidden"
             [formControlName]="item.key"
             [value]="item.value"
      />

      <!-- simple error display -->
      <div class="text-red-600 text-sm" *ngIf="form.get(item.key)?.invalid && form.get(item.key)?.touched">
        <ng-container *ngIf="form.get(item.key)?.errors?.['required']">Required.</ng-container>
        <ng-container *ngIf="form.get(item.key)?.errors?.['minlength']">Value is too short.</ng-container>
        <ng-container *ngIf="form.get(item.key)?.errors?.['maxlength']">Value is too long.</ng-container>
        <ng-container *ngIf="form.get(item.key)?.errors?.['email']">Invalid e-mail.</ng-container>
        <ng-container *ngIf="form.get(item.key)?.errors?.['profanity']">Some words not allowed.</ng-container>
        <ng-container *ngIf="form.get(item.key)?.errors?.['pattern']">Symbols and emojis are not allowed.</ng-container>
      </div>
    </ng-container>

    <button type="submit" class="button-primary">Save</button>
  </form>

  <content-block [slug]="'default-survey-bottom'" id="default-survey-bottom-wrapper"
                 [class.hidden]="boothMode"></content-block>
  <content-block [slug]="'wbm-survey-bottom'" id="wbm-survey-bottom-wrapper"
                 [class.hidden]=" ! boothMode"></content-block>


  <content-block [slug]="'default-disclaimer-bottom'" id="default-disclaimer-bottom-wrapper"
                 [class.hidden]="boothMode"></content-block>
  <content-block [slug]="'wbm-disclaimer-bottom'" id="wbm-disclaimer-bottom-wrapper"
                 [class.hidden]=" ! boothMode"></content-block>

</div>
